<template>
  <v-dialog v-model="dialog" persistent max-width="600px" content-class="configuration-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <ExecutionResultsDialog title="Station synchronization" @close="close()" ref="executionResultsDialog" />
    <template v-slot:activator="{ on }">
      <v-btn :disabled="!aquariusSynchronizer" v-on="on" class="info">
        <v-icon class="mr-2">refresh</v-icon>
        <div class="text-capitalize">Sync Aquarius Stations..</div>
      </v-btn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Sync Aquarius Stations</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card>
          <v-alert color="info" icon="info" class="ma-0 pa-2" outline :value="loading.sync">
            <div class="primary--text">
              The sync is currently running and can take between 10-20 minutes. You may close
              your browser or navigate to a different page.
            </div>
          </v-alert>

          <v-card-text class="py-3">
            <p>
              Synchronize the Aquarius stations to fetch the latest station and time series updates. These will be
              mapped to all tenants, but by default new entries will be disabled.
            </p>
            <v-radio-group v-model="syncOptions.aquariusServerType" row>
              <v-radio color="primary" v-for="(serverType, index) in AQUARIUS_SERVER_TYPES" :key="`serverType-${index}`" :label="serverType.name" :value="serverType.value"></v-radio>
            </v-radio-group>
            <!-- <v-autocomplete v-model="syncOptions.tenantIds" multiple chips clearable label="Only run for specified tenants" :items="tenants" item-text="RoleName" item-value="Id" persistent-hint hint="Leave empty to sync all tenants" /> -->
            <v-checkbox color="primary" class="mt-2" v-model="syncOptions.syncStationMetadata" label="Sync Station metadata" persistent-hint hint="Takes approximately 5 minutes longer." />
            <v-checkbox color="primary" class="mt-2" v-model="syncOptions.syncTimeSeries" label="Sync Time Series" persistent-hint hint="Takes approximately 10 minutes longer." />
            <v-checkbox color="error" class="mt-2" v-model="syncOptions.forceIfRunning" label="Force" persistent-hint hint="If a sync is already running, it will be restarted." />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <v-spacer />
            <v-btn :loading="loading.sync" @click="syncAquariusStations()" color="success">
              <v-icon left>sync</v-icon>Sync
            </v-btn>
            <v-btn color="secondary" outline @click="close()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const adminAquariusStations = createNamespacedHelpers('adminaquariusstation')
  const app = createNamespacedHelpers('app')
  const admin = createNamespacedHelpers('admin')

  const AQUARIUS_SERVER_TYPES = {
    aquariusNG: { name: 'Aquarius NG', value: 'AquariusNG' },    
  }

  export default {
    data: () => ({
      AQUARIUS_SERVER_TYPES,
      dialog: false,
      loading: {
        sync: false,
      },
      syncOptions: {
        aquariusServerType: AQUARIUS_SERVER_TYPES.aquariusNG.value,
        syncTimeSeries: false,
        forceIfRunning: false,
        syncStationMetadata: false,
        tenantIds: [],
      },
    }),
    computed: {
      ...adminAquariusStations.mapGetters(['aquariusSynchronizer']),
      ...admin.mapGetters(['roleList']),
      tenants() {
        return this.roleList.sort((a, b) => (a.RoleName > b.RoleName ? 1 : -1)) || []
      },
    },
    methods: {
      ...adminAquariusStations.mapActions(['fetchStations', 'synchronize']),
      ...app.mapActions(['setSnackbar']),
      //...admin.mapActions(['getRoleList']),
      async syncAquariusStations() {
        if (!this.aquariusSynchronizer) return

        this.loading.sync = true

        try {
          var result = await this.synchronize({
            service: this.aquariusSynchronizer,
            syncOptions: this.syncOptions,
          })

          this.$refs.executionResultsDialog.show(result)
        } catch (error) {
          this.$refs.executionResultsDialog.showError(error)
        }

        try {
          await this.fetchStations()
        } catch (error) {
          this.setSnackbar({
            text: 'Oops, the stations could not be refreshed. Please reload the page — let us know if it happens again!',
            color: 'error',
            icon: 'error',
          })
        }

        this.loading.sync = false
      },
      close() {
        this.dialog = false
      },
    },
    mounted() {
      //this.getRoleList()
    },
  }
</script>